(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["autoclinic-enquiry"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('autoclinic-enquiry')) return;
  customElements.define('autoclinic-enquiry', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.step = 0;
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      this.launcher = this.querySelector('.ace-launcher');
      this.panels = Array.from(this.querySelectorAll('[data-step]'));
      this.back = this.querySelector('.ace-back');
      this.next = this.querySelector('.ace-next');
      this.launcher.hidden = false;
      this.launcher.addEventListener('click', () => {
        this.dialog.showModal();
        this.showStep(this.step);
      });
      this.querySelector('.ace-close').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', () => this.launcher.focus());
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      this.back.addEventListener('click', () => this.showStep(Math.max(0, this.step - 1)));
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        if (this.step < 3 && this.validateStep(this.step)) this.showStep(this.step + 1);
      });
      this.form.addEventListener('input', (event) => {
        if (event.target.name === 'phone') event.target.setCustomValidity('');
      });
      this.form.addEventListener('change', (event) => {
        if (event.target.name !== 'category') return;
        const other = this.form.elements.other;
        const enabled = event.target.value === 'other';
        this.querySelector('[data-other-wrap]').hidden = !enabled;
        other.disabled = !enabled;
        other.required = enabled;
      });
      this.querySelectorAll('[data-channel]').forEach((link) => {
        link.addEventListener('click', (event) => {
          for (let step = 0; step < 3; step++) {
            this.showStep(step, false);
            if (!this.validateStep(step)) { event.preventDefault(); return; }
          }
          this.showStep(3, false);
        });
      });
    }
    validateStep(step) {
      const fields = this.panels[step].querySelectorAll('input:not(:disabled)');
      for (const field of fields) {
        if (field.type !== 'radio') field.value = field.value.trim();
        if (field.name === 'phone') {
          const digits = field.value.replace(/\D/g, '');
          const valid = /^[+\d\s()-]+$/.test(field.value) && digits.length >= 7 && digits.length <= 15;
          field.setCustomValidity(valid ? '' : this.dataset.phoneError);
        }
        if (!field.checkValidity()) { field.reportValidity(); return false; }
      }
      return true;
    }
    showStep(step, focus = true) {
      this.step = step;
      this.panels.forEach((panel, index) => { panel.hidden = index !== step; });
      this.back.hidden = step === 0;
      this.next.hidden = step === 3;
      this.querySelector('progress').value = step + 1;
      this.querySelector('[data-step-number]').textContent = step + 1;
      if (step === 3) this.buildEnquiry();
      if (focus) {
        this.dialog.scrollTop = 0;
        this.panels[step].querySelector('h3').focus({ preventScroll: true });
      }
    }
    buildEnquiry() {
      const fields = this.form.elements;
      const category = this.form.querySelector('input[name="category"]:checked');
      if (!category) return;
      const categoryText = category.dataset.title + (category.value === 'other' ? ': ' + fields.other.value.trim() : '');
      const rows = ['name', 'phone', 'email'].map((key) => [fields[key].dataset.label, fields[key].value.trim()]);
      rows.push([category.dataset.label, categoryText], [fields.car.dataset.label, fields.car.value.trim()]);
      const summary = this.querySelector('.ace-summary');
      summary.replaceChildren();
      rows.forEach(([label, value]) => {
        const term = document.createElement('dt');
        const detail = document.createElement('dd');
        term.textContent = label;
        detail.textContent = value;
        summary.append(term, detail);
      });
      const lines = [this.dataset.messageIntro, '', ...rows.map(([label, value]) => label + ': ' + value)];
      if (this.dataset.pageUrl) lines.push('', this.dataset.sourceLabel + ': ' + this.dataset.pageUrl);
      const message = lines.join('\n');
      this.querySelector('[data-channel="whatsapp"]').href = 'https://wa.me/' + this.dataset.whatsapp + '?text=' + encodeURIComponent(message);
      this.querySelector('[data-channel="email"]').href = 'mailto:' + this.dataset.email + '?subject=' + encodeURIComponent(this.dataset.subject) + '&body=' + encodeURIComponent(message);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
